import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { patchProjectExportUnits } from '@/api/projects';
import userApi from '@/api/user';

const initialValues = { settings: [] };
const useExportUnitsStore = create()(immer(() => initialValues));
const { setState: set } = useExportUnitsStore;

export const exportUnitsActions = {
  init: settings => set({ settings }),
  clear: () => set(initialValues, true),
  // `unit` is a unit name from the setting's options
  updateProject: async (projectId, name, unit) => {
    const { data } = await patchProjectExportUnits(projectId, { [name]: unit });
    set({ settings: data.settings });
  },
  updateAccount: async (name, unit) => {
    const { data } = await userApi.updateExportUnits({ [name]: unit });
    set({ settings: data.settings });
  },
};

export const useExportUnitSettings = () => useExportUnitsStore(store => store.settings);

export default useExportUnitsStore;
